<template>
  <div v-if="data.length">
    <van-row v-for="(item, index) in data" :key="index" type="flex" class="order-box" align="center">
      <van-col :span="12" class="border-right pt30 pb30 pl20">
        <van-row type="flex" align="center">
          <van-col>
            <van-image
              :src="_getPic(item.OrderProducts && item.OrderProducts[0].Logo, true)"
              :class="{ zengsong: item.OrderProducts && item.OrderProducts[0].IsGift }"
              fit="scale-down"
              width="100px"
              height="100px"
            />
          </van-col>
          <van-col class="pl10">
            <van-cell :value="`订单编号：  ${item.OrderNo}`" value-class=" f14 c777" :border="false" />
            <van-cell :value="`下单时间：  ${item.CreateTime}`" value-class="f14 c777" :border="false" />
            <van-cell value-class="f14 c777" :border="false">
              <template>
                订单内共
                <span class="c0F6EE9">{{ getProductsCount(item) }}</span>
                盒商品
              </template>
            </van-cell>
          </van-col>
        </van-row>
      </van-col>
      <van-col :span="12">
        <van-row type="flex" align="center">
          <van-col :span="8" class="border-right">
            <div class="f16 c222">
              ￥
              <span>{{ _getPriceArray(Number(item.TotalAmountPaidActual).toFixed(2))[0] }}</span>
              .{{ _getPriceArray(Number(item.TotalAmountPaidActual).toFixed(2))[1] }}
            </div>
            <div class="mt14 c222 f12 border-top">{{ item.PayMode }}</div>
          </van-col>
          <van-col :span="8" class="border-right">
            <div :class="item.status == '待付款' ? 'cFF3939 f16 fw600' : item.status == '待发货' ? 'c0F6EE9  f16 fw600' : 'c222  f16 fw400'">{{ item.status }}</div>
            <div v-if="item.status == '已发货'" class="mt14" @click.stop="() => handleViewLogistics(item.Id)">
              <a href="javascript:void(0)" class="c0F6EE9 f12 border-top">查看物流</a>
            </div>
          </van-col>
          <van-col :span="8" class="border-right">
            <div>
              <van-button
                v-if="item.status == '待付款' && !item.TotalAmountPaid && item.OrderPaymentState != 7 && item.IsCanPay"
                size="mini"
                class="mb10 payBtn"
                @click.stop="() => onPay(item)"
              >
                立即付款
              </van-button>
              <van-button
                v-if="
                  item.status == '待付款' &&
                    item.TotalAmountPaid &&
                    Number(item.TotalAmountPaidActual - item.TotalAmountPaid) > 0 &&
                    item.OrderPaymentState != 7 &&
                    item.IsCanPay
                "
                size="mini"
                class="mb10 plainPayBtn"
                @click.stop="() => onPay(item)"
              >
                继续支付
              </van-button>
              <van-button v-if="item.status == '已发货'" size="mini" class="mb10 plainBtn" @click.stop="() => handleConfirmGoods(item)">确认收货</van-button>

              <div v-if="item.status == '待付款'" class="mb6" @click.stop="() => cancelOrder(item)">
                <a href="javascript:void(0)" class="c999 f12 ihover">取消订单</a>
              </div>
              <!-- <div @click.stop="()=>cancelMoney(item)" class="mb6"
  v-if="item.OrderState==1&&item.OrderPaymentState == 2&&(!item.OrderLogisticsState || item.OrderLogisticsState == 6)&&item.OrderCustomerServiceState!=1">
  <a href="javascript:void(0)" class="c999 f12 ihover">申请退款</a>
</div> -->
              <div
                v-if="item.OrderState == 1 && item.OrderPaymentState == 2 && Number(item.TotalAmountPaidActual - item.TotalAmountPaid) <= 0"
                class="mb6"
                @click.stop="() => cancelMoney(item)"
              >
                <a href="javascript:void(0)" class="c999 f12 ihover">申请退款</a>
              </div>
              <div class="mb6" @click="() => goOrderDetails(item.Id)"><a href="javascript:void(0)" class="c999 f12 ihover">查看详情</a></div>
              <!-- <div class="mb6">
  <a href="javascript:void(0)" class="c999 f12 ihover">
    <van-icon name="down" size="12px" class="mr5" />下载检验报告
  </a>
</div>-->
              <div v-if="item.status != '待付款' && item.status != '已关闭' && !item.IsHasOrderInvoice" class="mb6" @click.stop="() => goApplyInvoice(item)">
                <a href="javascript:void(0)" class="c999 f12 ihover">申请开票</a>
              </div>
              <div v-if="item.status != '待付款' && item.status != '待发货' && IsOrder" class="mb6" @click.stop="() => handleRepurchase(item)">
                <a href="javascript:void(0)" class="ihover" :class="item.status != '已发货' ? 'c222 f12' : 'c0F6EE9 f12'">再次购买</a>
              </div>
              <!-- 纸质发票（弹窗），电子发表，维持原有模式跳转新页面展示 -->
              <div
                v-if="item.status != '待付款' && item.IsHasOrderInvoice && item.status != '已关闭' && item.OrderStatus !== 3"
                class="mb6"
                @click.stop="() => showInvoice(item)"
              >
                <a href="javascript:void(0)" class="c222 f12 ihover">查看发票</a>
              </div>
              <div v-if="item.status != '待付款' && item.status != '已关闭' && !item.IsHasOrderInvoiceAddress && item.IsHasOrderInvoice" class="mb6">
                <a href="javascript:void(0)" class="c222 f12 ihover">{{ item.InvoiceServiceState === 5 ? item.InvoiceServiceStateStr : '开票中' }}</a>
              </div>
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
    <!--
      * 查看发票物流信息 model
      * xuzhongqi
      * 2020.12.04
      -->
    <a-modal v-model="tipsModel" centered :footer="null" :closable="false" width="700px">
      <div class="tips-cont">
        <div class="tips-row">
          <h4>查看发票物流</h4>
          <img class="image-close" src="../assets/buycar/model-close.png" @click="() => (tipsModel = false)">
        </div>
        <div class="tips-logistics-cont">
          <div class="tips-logistics-title">
            <p>发票类型：增值税专用发票（纸质版）</p>
            <p>配送方式：{{ tipsModelDefaultData.LogisticsCompanyName }}</p>
            <p>快递单号：{{ tipsModelDefaultData.LogisticsWaybillNo }}</p>
          </div>
          <div v-if="tipsModelDefaultData !== '' && tipsModelDefaultData.LogisticsDocmentTrail.length > 0" class="tips-logistics-alternate">
            <a-timeline mode="left">
              <a-timeline-item v-for="(item, index) in tipsModelDefaultData.LogisticsDocmentTrail" :key="index" color="gray">
                <div class="alternate-item">
                  <div class="alternate-item-data">{{ item.Time }}</div>
                  <img class="alternate-item-icon" :src="index === 0 ? require('../assets/buycar/wl-active.svg') : require('../assets/buycar/wl.svg')">
                  {{ item.Note }}
                </div>
              </a-timeline-item>
            </a-timeline>
          </div>
          <div v-else class="tips-logistics-empty"><a-empty :description="false" /></div>
        </div>
      </div>
    </a-modal>
    <!-- 查看发票物流信息 model end -->
    <LookInvoiceInfo ref="lookinvoiceinfo" :order-state="orderState" />
    <CancelOrder ref="cancelorder" @againLoad="againLoad" />
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base.js'
import { BaseMixin } from '../mixins/BaseMixin.js'
import LookInvoiceInfo from '../views/mine/LookInvoiceInfo'
import CancelOrder from '../views/mine/CancelOrder'

export default {
  name: 'IOrderList',
  components: {
    LookInvoiceInfo,
    CancelOrder
  },
  mixins: [BaseMixin],
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      IsOrder: false,
      Info: null,
      // 查看发票物流 model
      tipsModel: false,
      // 查看发票物流 model 默认数据格式
      tipsModelDefaultData: '',
      orderState: ''
    }
  },
  mounted() {
    this.IsOrder = this.$auth.getCustomerOtherInfo().IsOrder
  },
  methods: {
    getProductsCount(item) {
      let Count = 0
      item.OrderProducts.map(item => {
        Count = Number(item.Count + Count)
      })
      return Count
    },
    // 订单详情
    goOrderDetails(id) {
      this.$emit('goDetails', id)
    },
    // 查看物流
    handleViewLogistics(id) {
      this.$emit('ViewLogistics', id)
    },
    // 再次购买
    async handleRepurchase(item) {
      const ProductList = []
      const glst = []
      item.OrderProducts.forEach(itm => {
        if (!itm.IsGift) {
          ProductList.push(itm)
          glst.push({ Id: itm.ProductSKUId, Count: itm.Count })
        }
      })
      this.$hys.openLoading()
      const res = await this.getAction('/api_order/ShoppingCarts/OrderBuyAgain', { orderId: item.Id })
      this.$hys.clearLoading()
      if (!res.IsSuccess || !res.Data) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }

      // OrderInfo.CommodityAmountSum + OrderInfo.FreebiesAmountSum
      this.$router.push({ name: LinkTypeCode.BuyCar })
    },
    // 申请开票
    goApplyInvoice(item) {
      this.$emit('goApplyInvoice', item)
    },
    // 查看发票
    handleLookInvoice(item) {
      this.$emit('getOrderNo', item.Id)
      this.$emit('lookApplyInvoice', item.Id)
    },
    // 确认收货
    handleConfirmGoods(item) {
      this.$emit('handleConfirmGoods', item)
    },
    // 取消订单
    cancelOrder(item) {
      this.$refs.cancelorder.handleShow(item)
      // this.$emit('cancelOrder', item);
    },
    againLoad() {
      this.$emit('againLoad')
    },
    // 申请退款
    cancelMoney(item) {
      this.$emit('cancelMoney', item)
    },

    // 付款
    async onPay(item) {
      this.$hys.openLoading()
      const payInfo = await this.getAction('/api_pay/ExpenseApplications/GetOrderPayInfo', { id: item.Id, no: item.OrderNo })
      this.$hys.clearLoading()
      if (payInfo && payInfo.IsSuccess) {
        const param = {
          OrderId: item.Id,
          OrderNo: item.OrderNo,
          PayMoney:
            !item.TotalAmountPaid || Number(item.TotalAmountPaidActual - item.TotalAmountPaid) == 0
              ? item.TotalAmountPaidActual
              : Number(item.TotalAmountPaidActual - item.TotalAmountPaid),
          PayInfo: payInfo.Data
        }
        this.$router.push({
          name: LinkTypeCode.SelectPay,
          params: param
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.SelectPay,
          params: {}
        })
      }
    },

    // 查看发票信息
    showInvoice(item) {
      // this.$refs.lookinvoiceinfo.handleShow(item.Id)
      this.$refs.lookinvoiceinfo.handleShow(item)
      this.orderState = item.status
    },
    async getInvoiceInfo(item) {
      const res = await this.getAction('/api_aftersale/OrderInvoice/GetOrderInvoice', { orderId: item.Id })
      if (res.IsSuccess && res.Data) {
        // 纸质发票
        if (res.Data[0].OrderInvoiceMediumType === 2 && res.Data[0].OrderInvoiceType === 2) {
          // 根据id获取物流信息
          const ids = []
          ids.push(res.Data[0].Id)
          const successData = await this.postAction('api_logistics/LogisticsDocment/GetLogisticsDocmentByOrderIds?businessDocmentType=4', ids)
          if (successData.IsSuccess && successData.Data.length > 0) {
            this.tipsModelDefaultData = successData.Data[0]
            // 开启model
            this.tipsModel = true
          } else {
            this.$toast.fail('暂无物流信息')
          }
        } else {
          // 非纸质发票，跳转发票详情页面
          this.Info = res.Data.length ? res.Data[0] : null
          window.open(this.Info.OrderEInvoiceAddress, '_blank')
        }
      } else {
        this.$toast.fail(res.Msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/styles/confirmOrder.less');

.order-box {
  margin-bottom: 22px;
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 2px;

  &:last-child {
    margin-bottom: 0;
  }

  .border-right {
    display: flex;
    justify-content: center;
    border-right: 1px solid #E8E8E8;
    height: 164px;
    flex-direction: column;

    &:last-child {
      border: 0;
    }

    .mb6 {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .border-top {
      position: relative;

      &::after {
        position: absolute;
        top: -7px;
        left: 50%;
        width: 139px;
        height: 1px;
        background: linear-gradient(to right, #FFFFFF 0%, #FFFFFF 20%, #E0E0E0 50%, #FFFFFF 80%, #FFFFFF 100%);
        content: '';
        transform: translateX(-50%);
      }
    }
  }

  .mt14 {
    margin-top: 14px;
  }
}

.van-cell {
  padding: 0;
}

.payBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  background: rgba(255, 57, 57, 1);
  line-height: 34px;
}

.plainPayBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 57, 57, 1);
  line-height: 34px;
}

.plainBtn {
  border: 1px solid #0F6EE9;
  border-radius: 2px;
  width: 104px;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  color: #0F6EE9;
  line-height: 34px;
}

/deep/ .van-cell:not(:last-child)::after {
  border-bottom: 0;
}

/deep/ .zengsong.van-image {
  position: relative;

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 30px;
    font-size: 10px;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 57, 57, .6);
    // content: '赠品';
    line-height: 30px;
  }
}

.wrapper {
  margin: 5% auto 0;
  width: 900px;
}
</style>
